import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  createPlan,
  type CreatePlanPayload,
  type CreatePlanResponse,
} from '@/api/planCreation'

/**
 * React Query hook for creating a new plan
 * @returns Mutation object with mutate, isPending, isError, error, and data
 */
export function useCreatePlan() {
  const queryClient = useQueryClient()

  return useMutation<CreatePlanResponse, Error, CreatePlanPayload>({
    mutationFn: createPlan,
    onSuccess: data => {
      console.log('Plan created successfully:', data)
      // Invalidate assortment plans query to refresh the table
      queryClient.invalidateQueries({ queryKey: ['assortment-plans'] })
      // Invalidate plan search queries to show new plan in search results
      queryClient.invalidateQueries({ queryKey: ['planSearch'] })
    },
    onError: error => {
      console.error('Failed to create plan:', error)
    },
  })
}
